import numberWithCommas from './numberWithCommas';

export const formatDollars = (number) => {
	return numberWithCommas(number ? Number(number || 0).toFixed(2) : '0.00');
};
